export class UserLogado {
    token;
    nome;
    cargo;
    id;
}